module.exports = __webpack_public_path__ + "static/bubble-background-787ee33bb57e3148e9013dd3b1436f1d.png";